import React, { useEffect, useState } from 'react'
import BreadCrumbBar from '../../common/breadCrumbBar/BreadCrumbBar'
import '../../css/common.css'
import { DataGrid } from '@mui/x-data-grid';
import SearchBar from '../../common/searchBar/SearchBar';
import ExportExcel from '../../common/excel/ExportExcel';
import moment from 'moment';
import { ApiService } from '../../services/apiService';
import { CircularProgress } from '@mui/material';
import Warning from '../../common/alert/Warning';
import { dateFormat } from '../../common';

export default function AdminActionList() {
  const [rowData, setRowData] = useState([]);
	let params = "";
	const [containData, setContainData] = useState({});
	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);
	const [rowCount, setRowCount] = useState(0);
	const [excelClick, setExcelClick] = useState(false);
	const [excelList, setExcelList] = useState([]);
	const [totalLength, setTotalLength] = useState(0);
	const [loading, setLoading] = useState(false);
	const [openWarning, setOpenWarning] = useState(false);
	const [errorMsg, setErrorMsg] = useState('');
	const [paginationModel, setPaginationModel] = useState({
		page: 0,
		pageSize: 30,
	});

	const closeWarning = (data) => {
		setOpenWarning(data);
	}

	const xlsxHeader = {
		header: [
			'관리자계정', '접속아이피', '작업내역', '작업일자'
		]
	}

	const today = moment().format('YYYY-MM-DD');
	const xlsxFileName = "관리자이력리스트_" + today;

	const getExcelData = async () => {
    setExcelClick(false);
    setLoading(true);
    params = `limit=${totalLength}`;

		try {
      const response = await ApiService.getAdminAction(params);
      const excelRows = response.data.datas.map((data) => {
        data.created = dateFormat(new Date(data.created));
        return {
          관리자계정: data.manager,
          접속아이피: data.remote,
          작업내역: data.action,
          작업일자: data.created,
        };
      });
      setExcelClick(true);
      setExcelList(excelRows);
    } catch (error) {
      console.log("AdminActionList - getExcelData - error :: ", error);
    } finally {
      setLoading(false);
    }
  };

	const columns = [
		{
			field: 'manager',
			headerName: '관리자아이디',
			minWidth: 350,
			flex: 1,
		},
		{
			field: 'remote',
			headerName: '접속아이피',
			minWidth: 350,
			flex: 1,
		},
		{
			field: 'action',
			headerName: '작업내역',
			minWidth: 200,
			flex: 1,
		},
		{
			field: 'created',
			headerName: '작업일자',
			minWidth: 180,
			flex: 1,
		},
	];

	const options = [
		{ 
			value: 'none',
			item: '검색할 항목 선택',
		},
		{ 
			value: 'manager',
			item: '관리자아이디',
		},
		{
			value: 'action',
			item: '작업내역',
		},
	];

	const getAdminActionList = async (limit, page, containData, startTime, endTime) => {
		if (startTime !== null && endTime !== null) {
			params = `limit=${limit}&offset=${limit*page}&contains=${JSON.stringify(containData)}&stime=${startTime}&etime=${endTime}`;
		} else {
			params = `limit=${limit}&offset=${limit*page}&contains=${JSON.stringify(containData)}`;
		}

		try {
			setLoading(true);
			const adminActionList = await ApiService.getAdminAction(params);
			//엑셀출력 시 전체 리스트를 조회해야되기 때문
			if(JSON.stringify(containData) === '{}' && (startTime === null && endTime === null)) {
				setTotalLength(adminActionList.data.total);
			}

			const rows = adminActionList.data.datas.map((data) => {
				data.created = dateFormat(new Date(data.created))
				return data;
			})

			setRowData(rows);
			setRowCount(adminActionList.data.total);
		} catch(error) {
			console.log('AdminActionList - getAdminActionList - error :: ', error);
		} finally {
			setLoading(false);
		}
	}

	useEffect(() => {
		//작업일자 검색할 경우
		if((startDate !== null) && (endDate !== null)) {
			//let timestampSecond = Math.floor(+ new Date("2022-10-23") / 1000)
			let startTime = Math.floor(new Date(startDate + " 00:00:00") / 1000);
			let endTime = Math.floor(new Date(endDate + " 23:59:59") / 1000);
			getAdminActionList(paginationModel.pageSize, paginationModel.page, containData, startTime, endTime);
		} else {
			getAdminActionList(paginationModel.pageSize, paginationModel.page, containData, null, null);
		}

	}, [paginationModel.page, containData, startDate, endDate])

	const getData = (selectValue, inputValue, start, end) => {
		const firstDate = moment(start);
		const secondDate = moment(end);
		const diffDay = moment.duration(secondDate.diff(firstDate)).asDays();

		if ((selectValue === "none") && (inputValue !== "")) {
			setOpenWarning(true);
			setErrorMsg('검색할 항목을 선택하세요!');
		} else {
			if(((start === null) && (end !== null)) || ((start !== null) && (end === null)) || (diffDay < 0)) {
				setOpenWarning(true);
				setErrorMsg('정확한 기간을 선택해주세요.');
			} else if(diffDay > 30) {
				setOpenWarning(true);
				setErrorMsg('조회 기간을 1개월(30일) 단위로 설정해주세요.');
			} else {
				setStartDate(start);
				setEndDate(end);
     
				if(inputValue === "") {
					setContainData({})
				} else {
					setContainData({ [selectValue]: inputValue.trim() })
				}
			}
		} 
	}

	return (
    <div className="containList">
      <BreadCrumbBar menu="이력 관리" smenu="관리자 이력 조회" />

      <div className="containItem">
        <div className="excelBtn" onClick={getExcelData}>
          <ExportExcel
            excelClick={excelClick}
            header={xlsxHeader}
            excelData={excelList}
            fileName={xlsxFileName}
          />
        </div>
        <SearchBar options={options} getData={getData} calendar={true} />
      </div>
      <div className="gridItem">
        {loading && (
          <CircularProgress
            sx={{ position: "absolute", top: "50%", left: "50%" }}
          />
        )}
        <DataGrid
          sx={{
            ".MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
            },
          }}
          rows={rowData}
          columns={columns}
          columnHeaderHeight={35}
          rowHeight={23}
          autoHeight={true}
          paginationMode="server"
          pageSizeOptions={[paginationModel.pageSize]}
          rowCount={rowCount}
          onPaginationModelChange={setPaginationModel}
          paginationModel={paginationModel}
          disableColumnMenu={true}
          disableSelectionOnClick
        />
      </div>

      <Warning
        open={openWarning}
        onHideWarning={closeWarning}
        warningMsg={errorMsg}
      ></Warning>
    </div>
  );
}
